import { IQuoteTable } from './interface';
import { IQuotesData } from 'models/Quote';
import { IBatchRequestResponse } from 'models/Batch';
import QuoteSevices from 'services/quote.service';
import React, { useEffect, useState, useCallback, useMemo } from 'react';

import TableSearch from 'components/TableSearch';
import Table from '..';
import QuoteDropdown from 'components/QuoteDropdown';
import { quoteModelComplete } from './models';
import { RootState } from 'store/ducks';
import { useSelector } from 'react-redux';
import { DateOutputStr } from 'utils/DateOutput';
import { Column } from 'components/Layout/Grid';

const QuoteTable: React.FC<IQuoteTable> = (props) => {
  const user = useSelector((state: RootState) => state.user);

  const {
    showFilter,
    completeBlankSpaces,
    showButton,
    showExportButton
  } = props;

  const [tableFilter, setTableFilter] = useState({
    and: [
      {
        quotationDate: {
          ge: new Date(
            `${DateOutputStr(
              getMinDate().toISOString(),
              'yyyy-MM-dd'
            )}T00:00:00.000Z`
          ),
        },
      },
      {
        quotationDate: {
          le: new Date(
            `${DateOutputStr(
              getMaxDate().toISOString(),
              'yyyy-MM-dd'
            )}T23:59:59.999Z`
          ),
        },
      },
    ],
  });

  const [tableOrder, setTableOrder] = useState('quotationDate desc');
  const [currentPage, setCurrentPage] = useState(0);
  // eslint-disable-next-line react/destructuring-assignment
  const pageTotal = props.pageSize || 10;

  /**
   * Quotes configs
   */
  const [quotes, setQuotes] = useState<IBatchRequestResponse<IQuotesData>>();

  const bottomButton = {
    label: '+ Ver todas as cotações',
    linkTo: '/cotacoes',
  };

  const exportData = useCallback(async () => {
    await new QuoteSevices().downloadData({ ...tableFilter }, tableOrder);
  }, [tableFilter, tableOrder]);

  const getQuotes = useCallback(async () => {
    setQuotes(undefined);

    await new QuoteSevices()
      .get(currentPage, pageTotal, tableOrder, tableFilter)
      .then((result: IBatchRequestResponse<IQuotesData> | undefined) => {
        if (result) {
          const { error, data, totalPages, pageSize, total } = result;
          setQuotes({ error, data, totalPages, pageSize, total });
        }
      });
  }, [tableOrder, currentPage, tableFilter]);

  const QuotesTableRender = useMemo(
    () => (
      <Table
        trackingKey="Grid Cotações"
        data={quotes?.data}
        className="mt-3"
        DropdownTemplate={QuoteDropdown}
        onReload={getQuotes}
        currentPage={currentPage}
        tableOrder={tableOrder}
        setTableOrder={setTableOrder}
        error={quotes?.error}
        totalPages={quotes?.totalPages}
        pageSize={pageTotal}
        onPageChange={setCurrentPage}
        model={props.model || quoteModelComplete}
        completeBlankSpaces={completeBlankSpaces || false}
        bottomButton={showButton ? bottomButton : undefined}
        /*exportButton={
          showExportButton ?
            {
              show: showExportButton,
              onClick: exportData,
            } :
            undefined
        }*/
        exportButton={{ show: false, onClick: () => {} }}
      />
    ),
    [quotes, user?.selectedCustomerId, tableOrder]
  );

  useEffect(() => {
    getQuotes();
  }, [getQuotes, tableOrder, user?.selectedCustomerId]);

  function getMinDate() {
    const minDate = new Date(new Date().toDateString());
    minDate.setMonth(minDate.getMonth() - 3);
    return minDate;
  }

  function getMaxDate() {
    return new Date(new Date().toDateString());
  }

  return (
    <>
      {showFilter && (
        <TableSearch
          trackingKey="Grid Cotações"
          inputFilter={{
            placeholder: 'N° da cotação, origem ou cliente',
            filters: (value) => [
              { code: { eq: value } },
              { 'tolower(code)': { eq: value } },
            ],
          }}
          dateKey="quotationDate"
          setTableFilter={setTableFilter}
          tableOrderBy={tableOrder}
          setTableOrderBy={setTableOrder}
          statusFilters={[
            { label: 'APROVADO', value: { status: { eq: 'APPROVED' } } },
            {
              label: 'AGUARDANDO APROVAÇÃO',
              value: { status: { eq: 'WAITING_APPROVAL' } },
            },
          ]}
          fastFilters={[
            { label: 'Mais recentes', value: 'quotationDate desc' },
            { label: 'Mais antigo', value: 'quotationDate asc' },
            { label: 'Próximos a expirar', value: 'timeShipping desc' },
          ]}
          setCurrentPage={setCurrentPage}
          dateMin={getMinDate()}
          dateMax={getMaxDate()}
        />
      )}
      <Column className="animated fadeInUp">
        {QuotesTableRender}
      </Column>
    </>
  );
};

export default QuoteTable;
